export default function Portfolio() {
  return (
    <section id="portfolio" className="py-12 sm:py-16 md:py-20 lg:py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 sm:mb-12 lg:mb-16">
          <p className="text-[#C9A961] text-xs sm:text-sm tracking-[0.2em] sm:tracking-[0.3em] uppercase font-light mb-3 sm:mb-4">
            Culinary Artistry
          </p>
          <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl text-gray-900 font-bold mb-4 sm:mb-6 px-4">
            Chef Ziad's Portfolio
          </h2>
          <p className="text-gray-600 text-sm sm:text-base md:text-lg font-light max-w-2xl mx-auto leading-relaxed px-4">
            Explore a curated collection of culinary masterpieces, showcasing years of expertise in fine dining and private chef services across London's most prestigious venues.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8 mb-8 sm:mb-12">
          <div className="group relative overflow-hidden rounded-lg shadow-lg hover:shadow-2xl transition-all duration-500">
            <div className="aspect-[4/3] w-full h-full bg-gray-100">
              <img
                src="https://public.readdy.ai/ai/img_res/ee9ffbcb420ba4c533a36f11c47a2df2.jpg"
                alt="Gourmet Appetizer"
                className="w-full h-full object-contain group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
              <div className="absolute bottom-0 left-0 right-0 p-4 sm:p-6">
                <h3 className="text-white font-serif text-lg sm:text-xl font-bold mb-1 sm:mb-2">Fine Dining Appetizers</h3>
                <p className="text-gray-200 text-xs sm:text-sm font-light">Artfully crafted starters</p>
              </div>
            </div>
          </div>

          <div className="group relative overflow-hidden rounded-lg shadow-lg hover:shadow-2xl transition-all duration-500">
            <div className="aspect-[4/3] w-full h-full bg-gray-100">
              <img
                src="https://readdy.ai/api/search-image?query=premium%20main%20course%20dish%20grilled%20meat%20with%20vegetables%20elegant%20plating%20professional%20food%20photography%20michelin%20star%20quality%20simple%20clean%20background%20luxury%20restaurant%20presentation%20gourmet%20cuisine&width=800&height=600&seq=portfolio002&orientation=landscape"
                alt="Main Course Excellence"
                className="w-full h-full object-contain group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
              <div className="absolute bottom-0 left-0 right-0 p-4 sm:p-6">
                <h3 className="text-white font-serif text-lg sm:text-xl font-bold mb-1 sm:mb-2">Signature Main Courses</h3>
                <p className="text-gray-200 text-xs sm:text-sm font-light">Premium cuts and fresh ingredients</p>
              </div>
            </div>
          </div>

          <div className="group relative overflow-hidden rounded-lg shadow-lg hover:shadow-2xl transition-all duration-500">
            <div className="aspect-[4/3] w-full h-full bg-gray-100">
              <img
                src="https://readdy.ai/api/search-image?query=exquisite%20dessert%20plating%20chocolate%20mousse%20with%20gold%20leaf%20berries%20artistic%20presentation%20professional%20food%20photography%20michelin%20star%20quality%20simple%20clean%20background%20luxury%20restaurant%20sweet%20course&width=800&height=600&seq=portfolio003&orientation=landscape"
                alt="Dessert Artistry"
                className="w-full h-full object-contain group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
              <div className="absolute bottom-0 left-0 right-0 p-4 sm:p-6">
                <h3 className="text-white font-serif text-lg sm:text-xl font-bold mb-1 sm:mb-2">Decadent Desserts</h3>
                <p className="text-gray-200 text-xs sm:text-sm font-light">Sweet perfection in every bite</p>
              </div>
            </div>
          </div>

          <div className="group relative overflow-hidden rounded-lg shadow-lg hover:shadow-2xl transition-all duration-500">
            <div className="aspect-[4/3] w-full h-full bg-gray-100">
              <img
                src="https://readdy.ai/api/search-image?query=luxury%20catering%20buffet%20spread%20elegant%20presentation%20multiple%20gourmet%20dishes%20professional%20event%20catering%20setup%20simple%20clean%20background%20high%20end%20corporate%20event%20food%20display&width=800&height=600&seq=portfolio004&orientation=landscape"
                alt="Event Catering"
                className="w-full h-full object-contain group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
              <div className="absolute bottom-0 left-0 right-0 p-4 sm:p-6">
                <h3 className="text-white font-serif text-lg sm:text-xl font-bold mb-1 sm:mb-2">Event Catering</h3>
                <p className="text-gray-200 text-xs sm:text-sm font-light">Memorable dining experiences</p>
              </div>
            </div>
          </div>

          <div className="group relative overflow-hidden rounded-lg shadow-lg hover:shadow-2xl transition-all duration-500">
            <div className="aspect-[4/3] w-full h-full bg-gray-100">
              <img
                src="https://readdy.ai/api/search-image?query=fresh%20seafood%20plating%20lobster%20prawns%20elegant%20presentation%20professional%20food%20photography%20michelin%20star%20quality%20simple%20clean%20background%20luxury%20restaurant%20seafood%20cuisine%20artistic%20arrangement&width=800&height=600&seq=portfolio005&orientation=landscape"
                alt="Seafood Specialties"
                className="w-full h-full object-contain group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
              <div className="absolute bottom-0 left-0 right-0 p-4 sm:p-6">
                <h3 className="text-white font-serif text-lg sm:text-xl font-bold mb-1 sm:mb-2">Seafood Specialties</h3>
                <p className="text-gray-200 text-xs sm:text-sm font-light">Ocean's finest delicacies</p>
              </div>
            </div>
          </div>

          <div className="group relative overflow-hidden rounded-lg shadow-lg hover:shadow-2xl transition-all duration-500">
            <div className="aspect-[4/3] w-full h-full bg-gray-100">
              <img
                src="https://readdy.ai/api/search-image?query=private%20dining%20table%20setup%20elegant%20place%20settings%20candles%20flowers%20luxury%20home%20dining%20experience%20professional%20event%20setup%20simple%20clean%20background%20intimate%20dinner%20party%20arrangement&width=800&height=600&seq=portfolio006&orientation=landscape"
                alt="Private Dining Setup"
                className="w-full h-full object-contain group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
              <div className="absolute bottom-0 left-0 right-0 p-4 sm:p-6">
                <h3 className="text-white font-serif text-lg sm:text-xl font-bold mb-1 sm:mb-2">Private Dining</h3>
                <p className="text-gray-200 text-xs sm:text-sm font-light">Intimate culinary experiences</p>
              </div>
            </div>
          </div>
        </div>

        <div className="text-center px-4">
          <a
            href="https://yallaziad.myportfolio.com"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center gap-2 sm:gap-3 w-full sm:w-auto px-6 sm:px-8 py-3 sm:py-4 bg-[#C9A961] text-white rounded-lg text-sm sm:text-base font-light tracking-wide transition-all hover:bg-[#B89851] hover:shadow-lg hover:shadow-[#C9A961]/30 whitespace-nowrap cursor-pointer"
          >
            <span>View Full Portfolio</span>
            <i className="ri-external-link-line text-base sm:text-lg"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
